import { IconArrowRight } from '@tabler/icons-react'
import { Button } from 'components/Button'
import ToastyLogo from 'components/ToastyLogo'

export const MarketingHeading = () => {
  return (
    <div className="flex items-center justify-between gap-2 pt-8 pb-2">
      <ToastyLogo className="!h-5 !w-auto" href="https://outcast.ai" />
      <div className="flex items-center gap-2">
        <Button
          size="lg"
          className="!bg-slate-800 !py-1.5 !font-jakarta !text-base !font-medium !text-white"
          icon={IconArrowRight}
          iconPosition="right"
          href="/register"
        >
          Try Free Now
        </Button>
      </div>
    </div>
  )
}
